var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"booking-shared-action",attrs:{"type":"button","title":"Print"},on:{"click":function($event){$event.stopPropagation();return _vm.onPrint.apply(null, arguments)}}},[_c('feather-icon',{attrs:{"icon":"PrinterIcon","svgClasses":"h-4 w-4"}}),_c('span',[_vm._v("Print")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }